import { TabPanel } from "@mui/lab";
import { useMemo } from "react";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import useTabSearchParams from "@entrilia/shared/hooks/useTabSearchParams";
import useClientContext from "../../../context/useClientContext";
import AgenticWorkflowsIcon from "../../common/domain-icons/AgenticWorkflowsIcon";
import PageTabs from "../../common/PageTabs";
import IntegrationPageContainer from "../integration/IntegrationPageContainer";
import AgentInboxesSettings from "./agent-inboxes/AgentInboxesSettings";
import WorkflowDefinitions from "./workflow-definitions/WorkflowDefinitions";

const AgenticWorkflowsPage = () => {
  usePageTitle("Agentic Workflows");

  const { hasAnyPermission } = useClientContext();

  const tabValues = useMemo(
    () => (hasAnyPermission(["ViewInboxes", "ManageInboxes"]) ? ["workflows", "inboxes"] : ["workflows"]),
    [hasAnyPermission]
  );

  const { selectedTab, onTabChange } = useTabSearchParams(tabValues);

  return (
    <IntegrationPageContainer
      title="Agentic Workflows"
      Icon={AgenticWorkflowsIcon}
      appStatus="Published"
      hideBorderLine
      disableGutters
    >
      <PageTabs tabs={tabValues} labels={["Workflows", "Agent Inboxes"]} value={selectedTab} onChange={onTabChange}>
        <TabPanel value="workflows" sx={{ p: 0, width: "100%", height: "100%" }}>
          <WorkflowDefinitions />
        </TabPanel>
        {tabValues.includes("inboxes") && (
          <TabPanel value="inboxes" sx={{ px: 3, pt: 2.5, width: "100%", height: "100%" }}>
            <AgentInboxesSettings />
          </TabPanel>
        )}
      </PageTabs>
    </IntegrationPageContainer>
  );
};

export default AgenticWorkflowsPage;
